





















































































import Vue from 'vue';
import _ from 'lodash';
import moment from 'moment-timezone';

import { ConsultaColetiva } from '../../../../back/src/entity/ConsultaColetiva';

import IfEmptyTextPrintNA from '../IfEmptyTextPrintNA.vue';

export default Vue.extend({
  name: 'TheConsultaColetivaDados',
  components: {
    IfEmptyTextPrintNA,
  },
  props: {
    consultaColetiva: {
      type: Object as () => ConsultaColetiva,
    },
  },
  data() {
    return {
    };
  },
  computed: {
    vRowClass(): string {
      if (this.$vuetify.breakpoint.xsOnly) {
        return 'd-flex flex-column';
      }
      return '';
    },
    agendadaInicioEm() {
      return moment(this.consultaColetiva.datetime_agendamento).format('DD/MM/YYYY  - HH:mm');
    },
    agendadaFimEm() {
      return moment(this.consultaColetiva.datetime_agendamento_fim).format('DD/MM/YYYY  - HH:mm');
    },
    iniciadaEm() {
      if (this.consultaColetiva.started != null) {
        return moment(this.consultaColetiva.started).format('DD/MM/YYYY - HH:mm');
      }
      return null;
    },
    finalizadaEm() {
      if (this.consultaColetiva.ended != null) {
        return moment(this.consultaColetiva.ended).format('DD/MM/YYYY - HH:mm');
      }
      return null;
    },
    canceladaEm() {
      if (this.consultaColetiva.datetime_cancelamento != null) {
        return moment(this.consultaColetiva.datetime_cancelamento).format('DD/MM/YYYY - HH:mm');
      }
      return null;
    },
  },
  methods: {
    linkConsultasVer(consultaId: number) {
      return {
        name: 'ConsultasVer',
        params: { consultaId },
      };
    },
  },
});
